import { Component, inject } from '@angular/core';
import { IonButtons, IonHeader, IonImg, IonMenuButton, IonToolbar } from "@ionic/angular/standalone";
import { IsLoggedInDirective } from "@shared/directives/auth/is-logged-in.directive";
import { DarkModeToggleComponent } from "@shared/components/dark-mode-toggle/dark-mode-toggle.component";
import { ViewportService } from "@core/services/viewport.service";
import { IsNotMobileDirective } from "@shared/directives/is-not-mobile.directive";
import { OnlineIndicatorComponent } from "@shared/components/online-indicator/online-indicator.component";
import { DbDumperComponent } from "@shared/components/db-dumper/db-dumper.component";

@Component({
  selector: 'pkp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {class: 'flex-row gap-24'},
  standalone: true,
  imports: [IonHeader, IonImg, IonToolbar, IonButtons, IonMenuButton, IsLoggedInDirective, DarkModeToggleComponent, IsNotMobileDirective, OnlineIndicatorComponent, DbDumperComponent]
})
export class HeaderComponent {
  private viewport = inject(ViewportService);
  isMobile = this.viewport.isMobile;
}
